export default __webpack_public_path__ + "static/media/client-11.7b576916.png";